import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheckCircle, FiX, FiInfo } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Toast = ({ message, type = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 50, x: '-50%' }}
      animate={{ opacity: 1, y: 0, x: '-50%' }}
      exit={{ opacity: 0, y: 20, x: '-50%' }}
      className="fixed bottom-10 left-1/2 z-[200] w-full max-w-sm px-4"
    >
      <div className={`flex items-center gap-4 p-4 rounded-sm shadow-2xl border ${
        type === 'success' ? 'bg-signal border-signal text-white' : 'bg-asphalt border-white/10 text-white'
      }`}>
        <SafeIcon icon={type === 'success' ? FiCheckCircle : FiInfo} className="text-xl shrink-0" />
        <p className="text-xs font-black uppercase tracking-widest flex-grow">{message}</p>
        <button onClick={onClose} className="p-1 hover:bg-black/20 rounded-sm transition-colors" aria-label="Close notification">
          <SafeIcon icon={FiX} />
        </button>
      </div>
    </motion.div>
  );
};

export default Toast;